import { Guid, Nillable } from '@web/utils';
import { Multimedia } from '@web/shared/module/multimedia';
import { PublicOrderItemComponentAttribute } from './public-order-item-component-attribute';

export class PublicOrderItemComponent {
  public constructor(
    private readonly data: {
      name: string;
      quantity: number;
      featuredFile?: Nillable<Multimedia>;
      sourceId?: Nillable<Guid>;
      sourceName?: Nillable<string>;
      attributes: PublicOrderItemComponentAttribute[];
    },
  ) {}

  public get name(): string {
    return this.data.name;
  }

  public get quantity(): number {
    return this.data.quantity;
  }

  public get featuredFile(): Nillable<Multimedia> {
    return this.data.featuredFile;
  }

  public get sourceId(): Nillable<Guid> {
    return this.data.sourceId;
  }

  public get sourceName(): Nillable<string> {
    return this.data.sourceName;
  }

  public get attributes(): PublicOrderItemComponentAttribute[] {
    return this.data.attributes;
  }
}
